import { IAutomationAppComponent } from "../../types";
import { schema, schemaFan } from "./types";
import { OverviewPanel,OperatorPanel,ConfigurationPanel } from '.';
import { DriveIconSimple } from "../DriveBase/DriveIcon";
import { OperationState } from "../OperationState";
import InsightsPanel from "./InsightsPanel";

export const App : IAutomationAppComponent = {
    schema: schema,
    supportsProcessPanel: true,
    Icon: DriveIconSimple,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    InsightsPanel: InsightsPanel,
    SideViewPanel: InsightsPanel,
    createConfig: {
        group: 'Aggregates',
        name: "Drive two speed",
        description: "Drive two speed",
        panel: OverviewPanel,
        defaultState: {  state: OperationState.Auto }
    }
}
export const AppFan : IAutomationAppComponent = {
    schema: schemaFan,
    supportsProcessPanel: true,
    Icon: DriveIconSimple,
    OverviewPanel: OverviewPanel,
    OperatorPanel: OperatorPanel,
    ConfigurationPanel: ConfigurationPanel,
    InsightsPanel: InsightsPanel,
    SideViewPanel: InsightsPanel,
    createConfig: {
        group: 'Aggregates',
        name: "Fan two speed",
        description: "Fan two speed",
        panel: OverviewPanel,
        defaultState: {  state: OperationState.Auto }
    }
}
